var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attuned"},[_c('h2',[_vm._v("Attuned items")]),_vm._l((_vm.inventory.attuned),function(item,id){return _c('div',{key:id},[_vm._v(" "+_vm._s(item.name)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }